var applicabilityDoc = {
  applicabilityCriteria: {},
  applicabilityCriteriaArray: [],
  listApplicabilities: {},
  isSetConfigurationVehicle: false,
  allConfigurationVehicle: [],
  PROPS_ATTRIBUTE: "props",
  OTHER_PROPS_ATTRIBUTE: "otherprops",
  PLATFORM_ATTRIBUTE: "platform",
  patterns: [{
      pattern: ["props", "otherprops", "platform"]
    },
    {
      pattern: ["audience"]
    }
  ],
  inclusive_suffix: "slmt",
  exclusive_suffix: "exclu",
  pathToAudienceData: "app/applicability/audience.json",
  data: null
};

applicabilityDoc.init = function (data, isSetConfigurationVehicle, pathToConfiguration, callback) {
  applicabilityDoc.allConfigurationVehicle = [];
  applicabilityDoc.applicabilityCriteriaArray = [];
  //applicabilityDoc.isSetConfigurationVehicle = isSetConfigurationVehicle;
  applicabilityDoc.isSetConfigurationVehicle = true;

  var listPromises = [];
  listPromises.push(applicabilityDoc.importConfigurationVehicle(pathToConfiguration, data));
  listPromises.push(applicabilityDoc.importListLanguges());
  listPromises.push(applicabilityDoc.importListCountries());

  Promise.all(listPromises).then(function () {
    prepareApplicabilityCriteria();
  }).catch(function (error) {
    prepareApplicabilityCriteria();
  });

  function prepareApplicabilityCriteria() {
    applicabilityDoc.applicabilityCriteriaArray = [];

    for (var i = 0; i < data.length; i++) {
      applicabilityDoc.applicabilityCriteriaArray.push(data[i])
    }

    applicabilityDoc.addOtherProperties().then(function () {
      if (callback !== undefined) {
        callback.apply(this, []);
      }
    }, function () {
      if (callback !== undefined) {
        callback.apply(this, []);
      }
    });
  }
}

applicabilityDoc.addOtherProperties = function () {
  return new Promise(function (resolve, reject) {
    if (vehicleManager.uuidVersionSelected != null && vehicleManager.uuidVersionSelected !== undefined) {
      ScanMyCar.getUserVehicleByUuid({
        "uuid": vehicleManager.uuidVersionSelected
      }, function success(userVehicle) {
        var language = "code-lang_" + userVehicle.language.toLowerCase();
        applicabilityDoc.applicabilityCriteriaArray.push(language);
        getUserCountry();
      })
    } else {
      getLanguage(function (value) {
        var language = "code-lang_" + value.toLowerCase();
        applicabilityDoc.applicabilityCriteriaArray.push(language);
        getUserCountry();
      });
    }

    function getUserCountry() {
      if (typeof device === "undefined") {
        //TODO FOR BO SCAN CONSULTATION
        resolve();
      } else {
        plugin.getPreference('userCountry',
          function success(countryCode) {
            var country = "code-pays_" + countryCode.toLocaleUpperCase();
            applicabilityDoc.applicabilityCriteriaArray.push(country);

            resolve();
          },
          function fail() {
            navigator.globalization.getPreferredLanguage(
              function (language) {
                var langSplit = language.value.split("-");

                var countryCode = "other";
                if (langSplit !== undefined && langSplit.length > 1) {
                  countryCode = langSplit[1];
                }
                var country = "code-pays_" + countryCode.toLocaleUpperCase();
                applicabilityDoc.applicabilityCriteriaArray.push(country);

                resolve();
              },
              function () {
                var langSplit = navigator.language.split("-");

                var countryCode = "other";
                if (langSplit !== undefined && langSplit.length > 1) {
                  countryCode = navigator.language.split("-")[1];
                }
                var country = "code-pays_" + countryCode.toLocaleUpperCase();
                applicabilityDoc.applicabilityCriteriaArray.push(country);

                resolve();
              }
            );
          }
        );
      }

    }
  });
}

applicabilityDoc.importConfigurationVehicle = function (pathToConfiguration, applicabilitiesCriteria) {
  return new Promise(function (resolve, reject) {
    if (typeof device !== "undefined" && (device.platform.toLowerCase() === "ios" || context.context === "plugin")) {
      var pathToConfigurationData = pathToConfiguration.split("/NoCloud/")
      pathToConfiguration = pathLocalStorage + pathToConfigurationData[pathToConfigurationData.length - 1];
    }

    $.ajax({
      url: pathToConfiguration + "/options.json",
      global: false,
      dataType: "json",
      async: true,
      success: function success(dataAjax, textStatusAjax, jqXHRAjax) {
        var data = dataAjax;
        for (var i = 0; i < data.length; i++) {
          var found = false
          var options = data[i].options;

          for (var j = 0; j < options.length; j++) {
            var listApplicabilities = options[j].listApplicabilities;
            if (applicabilityDoc.includesCriteria(applicabilitiesCriteria, listApplicabilities) === true) {
              found = true
              break
            }
          }

          if (found === true) {
            for (var j = 0; j < options.length; j++) {
              applicabilityDoc.allConfigurationVehicle = applicabilityDoc.allConfigurationVehicle.concat(options[j].listApplicabilities);
            }
          }
        }

        resolve();
      },
      error: function fail() {
        resolve();
      }
    });
  })
}

applicabilityDoc.importListLanguges = function () {
  return new Promise(function (resolve, reject) {
    var listLanguages = psa_params.data.listeLangues;
    for (key in listLanguages) {
      var language = listLanguages[key];
      applicabilityDoc.allConfigurationVehicle.push("code-lang_" + language["key"].toLowerCase());
    }
    resolve();
  })
}

applicabilityDoc.importListCountries = function () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: "app/country/data_country.json",
      global: false,
      dataType: "json",
      async: true,
      success: function success(dataCountry) {
        for (var i = 0; i < dataCountry.length; i++) {
          var countryInfos = dataCountry[i];
          applicabilityDoc.allConfigurationVehicle.push("code-pays_" + countryInfos.code.toLocaleUpperCase());
        }
        resolve();
      },
      error: function fail() {
        resolve();
      }
    });
  })
}

applicabilityDoc.shwoAllConfigurationVehicle = function () {
  for (var key in applicabilityDoc.allConfigurationVehicle) {
    console.log("criteria: " + applicabilityDoc.allConfigurationVehicle[key]);
  }
}

applicabilityDoc.includesCriteria = function (applicabilitiesCriteria, listApplicabilities) {
  for (var key in listApplicabilities) {
    if (applicabilitiesCriteria.includes(listApplicabilities[key]) === false) {
      return false
    }
  }

  return true
}

applicabilityDoc.testIfApplicable = function (listApplicabilitiesElement) {
  var listApplicabilities = applicabilityDoc.configurationMatch(listApplicabilitiesElement);
  if (listApplicabilities.length === 0) {
    return true;
  }

  var foundApplicability = false;
  var foundInclusiveAttribute = false;
  var foundExclusiveAttribute = false;

  for (var i = 0; i < applicabilityDoc.applicabilityCriteriaArray.length; i++) {
    var criteria = applicabilityDoc.applicabilityCriteriaArray[i];

    for (var j = 0; j < listApplicabilities.length; j++) {
      var suffixFound = false;
      var applicabilityValue = listApplicabilities[j];
      var applicabilityValueSplit = applicabilityValue.split("_");

      if (applicabilityValueSplit.length > 1) {
        var behavior = applicabilityValueSplit.pop()
        var value = applicabilityValueSplit.join('_')

        if (new String(behavior).valueOf() === new String(applicabilityDoc.inclusive_suffix).valueOf()) {
          suffixFound = true;
          foundInclusiveAttribute = true;
          if (new String(value).valueOf() === new String(criteria).valueOf()) {
            foundApplicability = true;
          }
        } else if (new String(behavior).valueOf() === new String(applicabilityDoc.exclusive_suffix).valueOf()) {
          suffixFound = true;
          if (new String(value).valueOf() === new String(criteria).valueOf()) {
            foundExclusiveAttribute = true;
            foundApplicability = false;
          }
        }
      }

      if (suffixFound === false) {
        if (new String(applicabilityValue).valueOf() === new String(criteria).valueOf()) {
          foundApplicability = true;
        }
      }
    }
  }

  if (foundExclusiveAttribute === true) {
    foundApplicability = false;
  } else if (suffixFound === true && foundInclusiveAttribute === false && foundExclusiveAttribute === false) {
    foundApplicability = true;
  }

  return foundApplicability;
}

applicabilityDoc.filter = function ($context, enableConfigurationMatch) {
  if (enableConfigurationMatch === undefined) {
    enableConfigurationMatch = true
  }

  if (applicabilityDoc.applicabilityCriteriaArray.length > 0) {
    for (var a = 0; a < applicabilityDoc.patterns.length; a++) {
      var pattern = applicabilityDoc.patterns[a].pattern;

      for (var j = 0; j < pattern.length; j++) {
        var attribut = pattern[j];
        if ((attribut === applicabilityDoc.PROPS_ATTRIBUTE || attribut === applicabilityDoc.OTHER_PROPS_ATTRIBUTE || attribut === applicabilityDoc.PLATFORM_ATTRIBUTE) && applicabilityDoc.isSetConfigurationVehicle === false) {
          continue;
        }

        var elements = $($context).find("[" + attribut + "]");

        for (var i = 0; i < elements.length; i++) {
          var $elementTarget = $(elements[i]);
          var dataApplicabilities = $($elementTarget).attr(attribut);
          var listApplicabilitiesElement = dataApplicabilities.split(" ");

          var listApplicabilitiesElementFiltered; // = []
          if (enableConfigurationMatch === true) {
            listApplicabilitiesElementFiltered = applicabilityDoc.configurationMatch(listApplicabilitiesElement);
          } else {
            listApplicabilitiesElementFiltered = listApplicabilitiesElement
          }

          var isApplicable = applicabilityDoc.testIfApplicable(listApplicabilitiesElementFiltered);

          if (isApplicable === false) {
            $($elementTarget).remove();
          }
        }
      }
    }
  }

  return $context;
}

applicabilityDoc.configurationMatch = function (listApplicabilitiesElement) {
  var listApplicabilitiesElementFiltered = [];

  for (var i = 0; i < listApplicabilitiesElement.length; i++) {
    var foundMatch = false;
    var suffixFound = false;
    var applicabilityValue = listApplicabilitiesElement[i];
    var applicabilityValueSplit = applicabilityValue.split("_");

    if (applicabilityValueSplit.length > 1) {
      var behavior = applicabilityValueSplit.pop()
      var value = applicabilityValueSplit.join('_')

      if (new String(behavior).valueOf() === new String(applicabilityDoc.inclusive_suffix).valueOf() || new String(behavior).valueOf() === new String(applicabilityDoc.exclusive_suffix).valueOf()) {
        suffixFound = true;
        if (applicabilityDoc.attributMatchConfiguration(new String(value).valueOf()) === true) {
          foundMatch = true;
        }
      }
    }

    if (suffixFound === false) {
      if (applicabilityDoc.attributMatchConfiguration(new String(applicabilityValue).valueOf()) === true) {
        foundMatch = true;
      }
    }

    if (foundMatch === true) {
      listApplicabilitiesElementFiltered.push(applicabilityValue);
    }
  }

  return listApplicabilitiesElementFiltered;
}

applicabilityDoc.attributMatchConfiguration = function (attribut) {
  var attributFound = false;

  for (var i = 0; i < applicabilityDoc.allConfigurationVehicle.length; i++) {
    if (applicabilityDoc.allConfigurationVehicle[i] === attribut) {
      attributFound = true;
      break;
    }
  }

  return attributFound;
}